import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Grid, TextField, Typography } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useState } from "react";
import { updateBankDetails, updateGst, updateUPI, validGst, validIfsc, validUpi } from "./admin_helper";

function BankChange({ data, onStateChange }) {
    const [inputErrors, setInputErrors] = useState({});

    const validateInputs = () => {
        setInputErrors({});
        return true;
    }

    const handleBankSave = (event) => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);
        const name = data.get("bank_name");
        const branch = data.get("bank_branch");
        const account = data.get("bank_account");
        const ifsc = data.get("bank_ifsc");

        var flag = true;
        if (!validIfsc(ifsc)) {
            setInputErrors({ inputErrors, "bank_ifsc": "Invalid IFSC code." });
            flag = false;
        }

        if (flag) {
            onStateChange(true);
            updateBankDetails(name, branch, account, ifsc).then((res) => {
                onStateChange(false);
                console.log(res);
            }).catch((err) => {
                onStateChange(false);
                console.error(err);
            })
        }
    }

    const handleUpiChange = (event) => {
        event.preventDefault();
        if (validUpi(event.target.value)) {
            updateUPI(event.target.value).then((res) => {
                setInputErrors({ inputErrors, "upi": "" });
                console.log(res);
            }).catch((err) => {
                console.log(err);
                setInputErrors({ inputErrors, "upi": err });
            });
        } else {
            setInputErrors({ inputErrors, "upi": "Invalid UPI address." });
        }
    }

    const handleGstChange = (event) => {
        event.preventDefault();
        const gst_num = event.target.value.toUpperCase();
        if (validGst(gst_num)) {
            updateGst(gst_num).then((res) => {
                setInputErrors({ inputErrors, "gst": "" });
                console.log(res);
            }).catch((err) => {
                console.log(err);
                setInputErrors({ inputErrors, "gst": err });
            });
        } else {
            setInputErrors({ inputErrors, "gst": "Invalid GST number." });
        }
    }

    return (
        <Accordion slotProps={{ transition: { unmountOnExit: true } }}>
            {/* <WarningConfirm /> */}
            <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="password-change" id="password-change">
                <Typography color="primary" variant="body2" component="span">Bank Setting</Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Box component="form" onSubmit={undefined}>
                    <Grid container spacing={2}>
                        <Grid size={{ xs: 12, sm: 6 }}>
                            <TextField variant="outlined" name="gst" defaultValue={data?.gst ?? ""} error={inputErrors.gst} helperText={inputErrors.gst} fullWidth type="text" placeholder="Ex 29XXXXX1314X9X6" label="GST Number" onBlur={handleGstChange} />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6 }}>
                            <TextField variant="outlined" name="upi" defaultValue={data?.upi ?? ""} error={inputErrors.upi} helperText={inputErrors.upi} fullWidth type="text" placeholder="upi-id@bank" label="UPI Address" onChange={handleUpiChange} />
                        </Grid>
                    </Grid>
                </Box>
                <Box component="form" onSubmit={handleBankSave}>
                    <Grid container spacing={2} sx={{ mt: 5 }}>
                        <Grid size={{ xs: 12, sm: 4 }}>
                            <TextField variant="outlined" name="bank_name" defaultValue={data?.bank_name ?? ""} error={inputErrors.bank_name} helperText={inputErrors.bank_name} fullWidth type="text" placeholder="Name of the bank" label="Bank Name" />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 4 }}>
                            <TextField variant="outlined" name="bank_branch" defaultValue={data?.bank_branch ?? ""} error={inputErrors.bank_branch} helperText={inputErrors.bank_branch} fullWidth type="text" placeholder="Branch Name" label="Bank Branch" />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 4 }}>
                            <TextField variant="outlined" name="bank_account" defaultValue={data?.bank_account ?? ""} error={inputErrors.bank_account} helperText={inputErrors.bank_account} fullWidth type="text" placeholder="Ex 1234XXXXXXXX" label="Bank Account Number" />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 4 }}>
                            <TextField variant="outlined" name="bank_ifsc" defaultValue={data?.bank_ifsc ?? ""} error={inputErrors.bank_ifsc} helperText={inputErrors.bank_ifsc} length={11} fullWidth type="text" placeholder="BXID0XXXXXX" label="Bank IFSC" />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 12 }}>
                            <Button type="submit" variant="contained" fullWidth onClick={validateInputs} color="info" style={{ textTransform: "none" }}>Save Bank Details</Button>
                        </Grid>
                    </Grid>
                </Box>
            </AccordionDetails>
        </Accordion>
    );
}
export default BankChange;
